import { gql } from '@apollo/client';

export const ALL_INSTITUTION_INTERVENTIONS_FOR_SELECT_INPUT = gql`
  query AllInstitutionInterventions($input: ExportArgs) {
    interventions: institutionInterventions(input: $input) {
      id
      name
    }
  }
`;
